import { createI18n } from "vue-i18n";

const ja = require('../../public/message/LanguageJp.json');
const en = require('../../public/message/LanguageEn.json');

const messages = {
  ja: ja,
  en: en,
};

const i18n = createI18n({
  // デフォルトで日本語を使用する
  locale: "ja",
  messages: messages
});

export default i18n